import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Result } from '../models/result';
import { SendSmsNotificationDTO } from '../../features/fila/models/sms-notification';

@Injectable({
  providedIn: 'root',
})
export class NotificacaoService {
  apiUrl = environment.urlControlCenterApi + 'notificacao';

  constructor(private http: HttpClient) {}

  sendSms(dto: SendSmsNotificationDTO) {
    return this.http.post<Result<boolean>>(this.apiUrl, dto);
  }
}
